export async function getDefaultGrapesSwipeTemplateSettings() {
  return await import('./defaultSalesMachineTemplateSettings').then((module) =>
    module.getDefaultGrapesSwipeTemplateSetting()
  )
}
